import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable, BehaviorSubject } from 'rxjs';

import DateTime from 'typescript-dotnet-es6/System/Time/DateTime';

import { RIAHelper } from './ria-helper';
import { environment } from '../../environments/environment';
import { AuditStdEdit } from './../main/rate-audit/ra-create/utilities/auditstd-edit-model';
import { AuditStd_AuditStatus } from './models/audit-std-audit-status';
import { MsgResult } from './models/msg-result';
import { FixToODataString } from './fix-to-odata-string';
import { qaPropertiesHeader } from './models/qa-properties-model';

@Injectable()
export abstract class RISDomainService extends BehaviorSubject<GridDataResult> {
  //  private BASE_URL: string = 'http://ri5-qai.lanyonhotel-dev.com/ClientBin/RateIntegritySuite-Web-Services-RISDomainService.svc/JSON/GetAuditStd_JobMonitor?customerID=185&filterStartDate=2%2f18%2f2016&filterEndDate=4%2f19%2f2017&filterAccount=ALL';
  private RIABASE_URL: string = environment.baseWebApiUrl + 'api/RIA/';
  private BASE_URL_API: string = environment.baseWebApiUrl + 'api/AuditStd/';
  private QABASE_URL: string = environment.baseWebApiUrl + 'api/QuickAuditServices/';

  private today = DateTime.now.date.toJsDate();
  private todayLess60days = DateTime.now.addDays(-60).toJsDate();

  defaultStartDate = (this.todayLess60days.getMonth() + 1) + '/' + this.todayLess60days.getDate() + '/' + this.todayLess60days.getFullYear();
  defaultEndDate = (this.today.getMonth() + 1) + '/' + this.today.getDate() + '/' + this.today.getFullYear();


  //'http://localhost:22363/ClientBin/RISite-RI5RIAServices-RISDomainService.svc/JSON/GetAuditScheduleByCustomerID?CustomerID=185'
  constructor(private http: Http, tableName: string) {
    super(null);
    this.tableName = tableName
  }
  tableName: string;
  query(state: any, filterStartDate, filterEndDate, filteredAccountName) {
    return this.GetAuditList(this.tableName, state, filterStartDate, filterEndDate, filteredAccountName)
  }

  private filterToString({ filter }: { filter?: string }): string {
    return filter ? `&$filter=${filter}` : '';
  }
  dynamicSort<T>(property: string, dir: string): (a: T, b: T) => number {
    let sortOrder = (dir === "desc") ? -1 : 1;
    return (a, b) => {
      let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }
  /**
   * ConvertDates
   */
  ConvertDates(rootResults: any[]) {

    rootResults.forEach((x, i: number, arr: any[]) => {
      x.DateImported = RIAHelper.ConvertToDate(x.DateImported);
      x.ScheduledRunDate = RIAHelper.ConvertToDate(x.ScheduledRunDate);
    })

  }

  GetAuditList(tableName: string, state: any, filterStartDate: any, filterEndDate: any, filteredAccountName: any): Observable<GridDataResult> {
    // debugger;
    if (filteredAccountName == undefined || filteredAccountName == "" || filteredAccountName == " ") {
      filteredAccountName = 'ALL';
    }
    if (filterStartDate == undefined) {
      filterStartDate = this.defaultStartDate;
    }
    if (filterEndDate == undefined) {
      filterEndDate = this.defaultEndDate;
    }
    let service = 'GetAuditStdJobMonitor?filterStartDate=' + filterStartDate + '&filterEndDate=' + filterEndDate + '&filterAccount=' + filteredAccountName;
    var stateStr = FixToODataString(state);
    var filterStr = this.filterToString(state);
    const queryStr = `${stateStr}&$count=true${filterStr}`;
    return this.http
      .get(this.RIABASE_URL + service).pipe(
        map(response => response.json()),
        map((response) => {
          if(response){
            let sorted = response;
            response.forEach(element => {
              var x = element.CustomerAccountName.toLowerCase();
              element.CustomerAccountNameLowerCase = x;
              if (element.QuickAuditID != null) {
                element.isQuickAudit = true;
              }
            });

            if (state.sort && state.sort.length > 0) {
              let srt = state.sort[0];
              let srtFn = this.dynamicSort(srt.field, srt.dir);
              sorted = sorted.sort(srtFn);
            }
            let subsetSorted = sorted.slice(state.skip, state.skip + state.take);
            this.ConvertDates(subsetSorted);
            return ({
              data: subsetSorted,
              total: sorted.length
            });
          }
          else{
            return {data:[],total:0};
          }
        }));
  }

  //Deleting audit from list
  DeleteAudit(auditID: string) {
    let service = 'AuditStdRemoveAuditStdRun';
    return this.http.post(this.RIABASE_URL + service, { auditID: auditID });
  }

  //Get account name list for search box
  GetAccountNameList(filterStartDate: any, filterEndDate: any) {
    if (filterStartDate == undefined) {
      filterStartDate = this.defaultStartDate;
    }
    if (filterEndDate == undefined) {
      filterEndDate = this.defaultEndDate;
    }
    let service = 'GetAuditStdDistinctListOfAccounts?filterStartDate=' + filterStartDate + '&filterEndDate=' + filterEndDate;
    return this.http.get(this.RIABASE_URL + service).pipe(
      map(response => response.json()),);
  }

  //Get account name list for search box
  GetAccountNameListForGDSUSage(filterStartDate: any, filterEndDate: any) {
    if (filterStartDate == undefined) {
      filterStartDate = this.defaultStartDate;
    }
    if (filterEndDate == undefined) {
      filterEndDate = this.defaultEndDate;
    }
    let service = 'GetAuditStdDistinctListOfAccountsForGDSUSage?filterStartDate=' + filterStartDate + '&filterEndDate=' + filterEndDate;
    return this.http.get(this.RIABASE_URL + service).pipe(
      map(response => response.json()),);
  }

  //Rate Audit summary report
  GetAuditListForSummaryReport(state: any): Observable<GridDataResult> {
    let service = 'GetAllProcessedStandardAuditsByCustomerID';
    var stateStr = FixToODataString(state);
    var filterStr = this.filterToString(state);
    const queryStr = `${stateStr}&$count=true${filterStr}`;
    return this.http.get(this.RIABASE_URL + service).pipe(
      map(response => response.json()),
      map((response) => {
        let summaryGridData = response;
        summaryGridData.forEach(item => {
          item.checked = false;
          return item;
        }
        )
        if (state.sort && state.sort.length > 0) {
          let srt = state.sort[0];
          let srtFn = this.dynamicSort(srt.field, srt.dir);
          summaryGridData = summaryGridData.sort(srtFn);
        }
        return ({
          data: summaryGridData,
          total: summaryGridData.length
        });
      }));
  }

  SaveAudit(audit: AuditStdEdit): Observable<MsgResult> {
    let service = 'CreateAuditStd';
    return this.http.post(this.RIABASE_URL + service, audit.GetSubmitModel()).pipe(
      map(response => response.json()),);
  }

  //Get data for chart audit
  GetRAChart(auditID: any) {

    let service = 'GetAuditStdReportGraphGetStatusCounts?auditId=' + auditID;
    return this.http.get(this.RIABASE_URL + service).pipe(
      map(response => response.json()),);
  }


  //get notification template for notification editor
  //AuditType=1 for rate audit
  GetNotificationTemplate() {

    let service = 'GetNotificationTemplates';
    return this.http.get(this.RIABASE_URL + service + "?AuditType=1").pipe(
      map(response => response.json()));
  }

  GetRunningStatus(auditIds: string[]): Observable<AuditStd_AuditStatus[]> {
    let service = 'GetAuditStdStatusList';
    return this.http.post(this.RIABASE_URL + service, { auditIDs: auditIds }).pipe(
      map(response => response.json()),);
  }
  ApproveAuditToRun(auditID: string): Observable<MsgResult> {
    let service = 'AuditStdAuditMarkAsApproved';
    return this.http.post(this.RIABASE_URL + service, {auditID : auditID}).pipe(
      map(response => response.json()),);
  }

  public getRFPAccounts(contractperiod: number): Observable<any> {
    let service = 'GetRFPAccountList';
    return this.http
      .get(this.QABASE_URL + service + "?contractPeriod=" + contractperiod).pipe(
        map((response) => response.json()),
        map(response => {
          return response.customers;
        }));
  }
  public getQAProperties(contractperiod: number, channelID?: number, quickAuditID?: string): Observable<qaPropertiesHeader> {
    return this.http
      .post(this.QABASE_URL + "GetProperties", { contractPeriod: contractperiod, channelID: channelID, quickAuditID: quickAuditID }).pipe(
        map((response) => response.json()),
        map(response => {
          return response;
        }));
  }
  public beginGetQAProperties(contractperiod: number, channelID?: number, quickAuditID?: string): Observable<string> {
    return this.http
      .post(this.QABASE_URL + "BeginGetProperties", { contractPeriod: contractperiod, channelID: channelID, quickAuditID: quickAuditID }).pipe(
        map((response) => response.json()),
        map(response => {
          return response;
        }));
  }
  public pollQAProperties(trackingGuid: string): Observable<qaPropertiesHeader> {
    return this.http
      .post(this.QABASE_URL + "PollGetProperties", { guid: trackingGuid }).pipe(
        map((response) => response.json()),
        map(response => {
          return response;
        }));
  }
}

@Injectable()
export class RAProductsService extends RISDomainService {
  constructor(http: Http) { super(http, "Products"); }

  /*
    queryForCategory({ CategoryID }: { CategoryID: number }, state?: any): void {
      this.query(Object.assign({}, state, { "filter": `CategoryID eq ${CategoryID}` }));
    }

    queryForProductName(ProductName: string, state?: any): void {
      this.query(Object.assign({}, state, { "filter": `contains(ProductName, '${ProductName}')` }));
    }
    */

}

@Injectable()
export class RaService extends RISDomainService {
  constructor(http: Http) { super(http, "AuditStd_Audit"); }
}

